module.exports = __webpack_public_path__ + "9339007160a36ff0f8c8e599de0aad51.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/MK.svg
// module id = mGEn
// module chunks = 0